const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];
  for (let rawData of listRawData) {
    const row = {};

    if (rawData.data_kendaraan) {
      row["tanggal_transaksi"] = rawData.tanggal_transaksi;
      row["jenis_minyak"] = rawData.data_jenis_minyak.nama;
      row["km"] = rawData.speedo_akhir;
      row["harga"] = rawData.harga_per_liter;
      row["liter"] = rawData.jumlah;
      row["total"] = rawData.total_harga;

      _list.push(row);
    }
  }
  return _list;
};

export default ReportTemplateReformatCopyData;
